import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { assigneeMapping } from 'src/app/Models/BasicForms/assigneeMapping';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-assignee-mapping',
  templateUrl: './assignee-mapping.component.html',
  styleUrls: ['./assignee-mapping.component.css']
})

export class AssigneeMappingComponent implements OnInit {
  @Input() drawerClose: Function;
  @Input() data: assigneeMapping;
  @Input() typeData: number;
  @Input() typeIDData: number;
  menu: any
  constructor(public _apiService: ApiService, private notificationService: NzNotificationService, private datePipe: DatePipe) { }

  ngOnInit(): void {
    this.loadAllAssignee();
  }

  assigneeData = [];
  logtext: string = "";
  isSpinning = false;

  save(addNew: boolean): void {
    var isOk = true;

    if (this.data.ASSIGNEE_ID != undefined) {
      if (this.data.ASSIGNEE_ID.length == 0) {
        isOk = false;
        this.notificationService.error("Please Select Assignee", "");
      }
    } else {
      isOk = false;
      this.notificationService.error("Please Select Assignee", "");
    }

    if (isOk) {
      this.isSpinning = true;
      this.data.TYPE = this.typeData;
      this.data.REFERENCE_ID = this.typeIDData;
      this.data.ASSIGNEE_ID = this.data.ASSIGNEE_ID.toString();
      this.data.REPORTER_ID = this._apiService.userId;
      this.data.STATUS = "P";



      this._apiService.updateAssignees(this.data).subscribe(successCode => {
        if (successCode['code'] == "200") {
          this.notificationService.success("Assignee Updated Successfully", "");
          this.close();

        } else {
          this.notificationService.error("Failed to Update Assignee", "");
        }

      }, err => {
        if (err["ok"] == false) {
          this.notificationService.error("Server Not Found", "");
        }
      });

      this.data.ASSIGNEE_ID = [];
    }
  }

  close() {
    this.drawerClose();
  }

  getAssignee(t, tIdD) {
    this.ASSIGNEE_ID1 = [];

    this._apiService.getAllAssignees(0, 0, 'ID', 'desc', ' and TYPE=' + t + " and REFERENCE_ID=" + tIdD).subscribe(userData => {

      this.assigneeData = userData['data'];

      for (var i = 0; i < this.assigneeData.length; i++) {
        this.ASSIGNEE_ID1.push(this.assigneeData[i]['ASSIGNEE_ID']);
      }
      this.data.ASSIGNEE_ID = this.ASSIGNEE_ID1;

    }, err => {

    });
  }

  assigneeList = [];
  ASSIGNEE_ID1 = [];

  loadAllAssignee() {
    this.assigneeList = [];
    var USER_ID = this._apiService.userId;

    this._apiService.getAllUsers(0, 0, 'ID', 'desc', ' and ID!=' + USER_ID).subscribe(userData => {

      this.assigneeList = userData['data'];

    }, err => {

    });
  }
}
